/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { EditActorResponseJson } from './edit-actor-response-json';
import { EditActorResult } from '../results/edit-actor-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ActorDto } from '../models/actor-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class EditActorResponse extends ResponseWithErrorGeneric<EditActorResponseJson, EditActorResult> implements IResponseWithErrorGeneric<EditActorResult> {
  public actor: ActorDto;

  //<custom-body>
  constructor(response: HttpResponse<EditActorResponse>) {
      super(response, EditActorResult.Error);
      if (this.result === EditActorResult.Success) {
        this.actor = new ActorDto(this.body.actor);
      }
    }
  //</custom-body>
}
